import { NativeBridge } from './NativeBridge';
import { createStore$ } from '../createStore$';

const ReactNativeWebView = (window as any)?.webkit?.messageHandlers?.ReactNativeWebView;
const _isNative = Boolean(ReactNativeWebView);

export namespace Native$ {
    export const isNative = _isNative;

    type State = Partial<{
        brightness: number;
    }>;

    const state = createStore$<State>({
        cacheKey: 'Native$',
        initialState: {
            brightness: 0.5,
        },
    });

    export const useState = state.useState;

    export async function execute<F extends keyof NativeBridge>(
        fn: F,
        input?: NativeBridge[F][0],
    ): Promise<NativeBridge[F][1]> {
        return (await post(fn, input)) as any;
    }
}

const callbacks: Record<string, any> = {};

function post(type, data) {
    const callbackId = Math.random();
    const promise = new Promise((resolve, reject) => (callbacks[callbackId] = { resolve, reject }));

    if (_isNative) {
        ReactNativeWebView.postMessage(JSON.stringify({ type, data, callbackId }));
    }

    return promise;
}

function registerEventHandlers() {
    isRegistered = true;

    function handleEvent(event) {
        try {
            const { callbackId, error, data } = JSON.parse(event.data);

            if (callbacks[callbackId]) {
                if (error) {
                    callbacks[callbackId].reject(data);
                } else {
                    callbacks[callbackId].resolve(data);
                }

                delete callbacks[callbackId];
            }
        } catch (error) {}
    }

    document.addEventListener('message', handleEvent);
    window.addEventListener('message', handleEvent);
}

let isRegistered = false;

if (!isRegistered) {
    registerEventHandlers();
}
